document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".sections");

  if (!section) {
    console.error("Section not found!");
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          section.classList.add("visible");
        }
      });
    },
    { threshold: 0.5 } 
  );

  observer.observe(section);
  document.addEventListener("scroll", function () {
    const imageContainer = document.querySelector(
      ".grid-item.first .image-container"
    );
    const rect = imageContainer.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (rect.top <= windowHeight && rect.bottom >= 0) {
      imageContainer.classList.add("visible");
    }
  });
});
